import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.jsx';
import ErrorBoundary from './components/ErrorBoundary.jsx';
import './index.css';

function FullAppFallback(error, reset) {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-3 bg-ink-900 p-6 text-center text-slate-200">
      <div className="text-sm font-semibold uppercase tracking-wider text-red-300">
        VIBRANIAM SPACE — errore imprevisto
      </div>
      <div className="max-w-lg whitespace-pre-wrap break-words rounded border border-red-500/30 bg-red-950/30 p-3 font-mono text-[11px] leading-snug text-red-200/80">
        {String(error?.message || error)}
      </div>
      <p className="max-w-md text-[11px] text-slate-500">
        L&apos;ultima patch salvata in automatico verrà ricaricata al riavvio.
      </p>
      <button
        type="button"
        onClick={reset}
        className="rounded bg-vibe-cyan px-4 py-2 text-[12px] font-semibold text-ink-900 transition hover:brightness-110"
      >
        Riavvia l&apos;app
      </button>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <ErrorBoundary label="App" renderFallback={FullAppFallback}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
